import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, isRef as _isRef, createVNode as _createVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-row flex-wrap gap-x-12 gap-y-3 text-sm mt-3"
}
const _hoisted_2 = ["data-dusk"]
const _hoisted_3 = { class: "font-semibold text-sm text-gray-900" }
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_5 = { class: "font-semibold text-xs text-gray-500" }
const _hoisted_6 = { class: "font-semibold text-sm text-gray-900" }
const _hoisted_7 = {
  key: 0,
  class: "mt-6"
}
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = { class: "mr-4 -ml-4 flex items-center" }
const _hoisted_10 = { class: "flex-1" }
const _hoisted_11 = { class: "flex flex-wrap w-full" }
const _hoisted_12 = {
  key: 0,
  class: "w-1/6"
}
const _hoisted_13 = { class: "flex flex-row justify-between px-2" }
const _hoisted_14 = {
  class: "flex flex-col w-full",
  "data-dusk": "cart-item-option"
}
const _hoisted_15 = { class: "font-semibold text-xs text-gray-500" }
const _hoisted_16 = { class: "font-semibold text-sm text-gray-900" }
const _hoisted_17 = { class: "w-1/6" }
const _hoisted_18 = { class: "flex flex-row justify-between px-2" }
const _hoisted_19 = {
  class: "flex flex-col w-full",
  "data-dusk": "cart-item-option"
}
const _hoisted_20 = { class: "font-semibold text-xs text-gray-500" }
const _hoisted_21 = { class: "font-semibold text-sm text-gray-900" }
const _hoisted_22 = {
  key: 1,
  class: "max-w-2/6 w-auto mr-4"
}
const _hoisted_23 = { class: "flex flex-row justify-between px-2" }
const _hoisted_24 = {
  class: "flex flex-col w-full",
  "data-dusk": "cart-item-option"
}
const _hoisted_25 = { class: "font-semibold text-xs text-gray-500" }
const _hoisted_26 = { class: "font-semibold text-sm text-gray-900" }
const _hoisted_27 = {
  key: 2,
  class: "max-w-2/6 w-auto"
}
const _hoisted_28 = { class: "flex flex-row justify-between px-2" }
const _hoisted_29 = {
  class: "flex flex-col w-full",
  "data-dusk": "cart-item-patient"
}
const _hoisted_30 = { class: "font-semibold text-xs text-gray-500" }
const _hoisted_31 = { class: "font-semibold text-sm text-gray-900" }
const _hoisted_32 = {
  key: 1,
  class: "grid grid-cols-5 gap-6 mt-6 items-end"
}
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { class: "col-span-5 mt-2" }

import { useOrderCard } from '@/composables/use-order-card';
import { BaseTextInput, NumberInput } from '@/lib/components/Input';
import { BaseSelectDropdown } from '@/lib/components/Select';
import { SearchInput } from '@/lib/components/Search';
import { useI18n } from 'vue-i18n';
import { OrderItem } from '@/models/webshop.model';
import BaseCheckbox from '@/lib/components/Checkbox/BaseCheckbox.vue';
import BaseOrderCard from './BaseOrderCard.vue';
import AddPatientModal from '@/views/patient/AddPatientModal.vue';
import { Patient } from '@/models';
import { useRoute } from 'vue-router';
import { ref, watch, computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  ...{ inheritAttrs: false },
  __name: 'OrderCardLens',
  props: {
    item: {},
    isLoading: { type: Boolean },
    category: {},
    editable: { type: Boolean },
    isSelected: { type: Boolean },
    dataDusk: {},
    onPatientSettingChange: { type: Function }
  },
  emits: ['remove-item', 'update-item', 'select-item'],
  setup(__props: any, { emit: __emit }) {



const props = __props;

const emit = __emit;
const { t } = useI18n();
const route = useRoute();
const baseCardRef = ref<InstanceType<typeof BaseOrderCard> | null>(null);
const showModal = ref(false);
const currentOrganisationId = computed(() => route.params.organisationId as string);

const {
  isSelected,
  isUserEditingQuantity,
  isUserEditingReference,
  editableFields,
  safeQuantity,
  packOptions,
  displayOptions,
  validateReference,
  handleSelectionChange,
  getFallbackImage,
  patientSearchText,
  patientSuggestions,
  isPatientSearchLoading,
  handlePatientChange
} = useOrderCard(props, emit, { onPatientSettingChange: props.onPatientSettingChange });

const handlePatientCreated = (newPatient: Patient) => {
  const patientSuggestion = {
    id: newPatient.id,
    value: newPatient.id,
    label: `${newPatient.first_name} ${newPatient.last_name} - ID: ${newPatient.mrn}` ||
      `${newPatient.first_name} ${newPatient.last_name}`
  };

  handlePatientChange(patientSuggestion);
  showModal.value = false;
};

watch(() => props.isLoading, (newVal) => {
  if (baseCardRef.value && !newVal && baseCardRef.value.isLoadingLocal) {
    baseCardRef.value.resetRemovingState();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BaseOrderCard, _mergeProps(_ctx.$attrs, {
      ref_key: "baseCardRef",
      ref: baseCardRef,
      item: _ctx.item,
      category: _ctx.category,
      editable: _ctx.editable,
      "is-loading": _ctx.isLoading,
      "data-dusk": _ctx.dataDusk,
      "fallback-image": typeof _unref(getFallbackImage) === 'function' ? _unref(getFallbackImage)(_ctx.category) : '',
      onUpdateItem: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('update-item', $event))),
      onSelectItem: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('select-item', $event))),
      onRemoveItem: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('remove-item', $event)))
    }), {
      "display-options": _withCtx(() => [
        (_unref(displayOptions).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(displayOptions), (option) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: option.key,
                  "data-dusk": "cart-item-option",
                  class: "flex flex-col"
                }, [
                  _createElementVNode("div", {
                    class: "font-semibold text-xs text-gray-500",
                    "data-dusk": `cart-item-option-${option.key}`
                  }, _toDisplayString(option.label), 9, _hoisted_2),
                  _createElementVNode("div", _hoisted_3, _toDisplayString(option.value), 1)
                ]))
              }), 128)),
              (_ctx.item.isStock && _ctx.item?.variantOptionLabel)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('platform.webshop.pack')), 1),
                    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.item?.variantOptionLabel), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        (!_ctx.editable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(BaseCheckbox, {
                    modelValue: _unref(isSelected),
                    "onUpdate:modelValue": [
                      _cache[0] || (_cache[0] = ($event: any) => (_isRef(isSelected) ? (isSelected).value = $event : null)),
                      _cache[1] || (_cache[1] = (value) => _unref(handleSelectionChange)(value as boolean))
                    ],
                    name: _ctx.item.id,
                    border: false,
                    shadow: false,
                    label: ''
                  }, null, 8, ["modelValue", "name"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    (_ctx.item?.variantOptionLabel)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(t)('platform.webshop.pack')), 1),
                              _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.item?.variantOptionLabel), 1)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(t)('platform.webshop.quantity')), 1),
                          _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.item.quantity), 1)
                        ])
                      ])
                    ]),
                    (_ctx.item.reference)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(t)('platform.webshop.reference')), 1),
                              _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.item.reference), 1)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.item.patientId)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(t)('platform.webshop.patient')), 1),
                              _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(patientSearchText)), 1)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_32, [
              (_unref(packOptions) && _unref(packOptions).length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _createVNode(_unref(BaseSelectDropdown), {
                      modelValue: _unref(editableFields).packValue,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(editableFields).packValue) = $event)),
                      label: _unref(t)('platform.webshop.pack'),
                      placeholder: _unref(t)('platform.webshop.placeHolders.pack'),
                      options: _unref(packOptions),
                      "data-dusk": "cart-item-select"
                    }, null, 8, ["modelValue", "label", "placeholder", "options"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                onFocusin: _cache[4] || (_cache[4] = ($event: any) => (isUserEditingQuantity.value = true)),
                onFocusout: _cache[5] || (_cache[5] = ($event: any) => (isUserEditingQuantity.value = false))
              }, [
                _createVNode(_unref(NumberInput), {
                  modelValue: _unref(safeQuantity),
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(safeQuantity) ? (safeQuantity).value = $event : null)),
                  modelModifiers: { number: true },
                  label: _unref(t)('platform.webshop.quantity'),
                  min: 1,
                  placeholder: _unref(t)('platform.webshop.placeHolders.quantity'),
                  "data-dusk": "cart-quantity-input"
                }, null, 8, ["modelValue", "label", "placeholder"])
              ], 32),
              _createElementVNode("div", {
                class: _normalizeClass(["flex gap-6 items-end", _unref(packOptions) && _unref(packOptions).length > 0 ? 'col-span-3' : 'col-span-4'])
              }, [
                _createElementVNode("div", {
                  class: "flex-1",
                  onFocusin: _cache[7] || (_cache[7] = ($event: any) => (isUserEditingReference.value = true)),
                  onFocusout: _cache[8] || (_cache[8] = ($event: any) => (isUserEditingReference.value = false))
                }, [
                  _createVNode(_unref(BaseTextInput), {
                    modelValue: _unref(editableFields).reference,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(editableFields).reference) = $event)),
                    label: _unref(t)('platform.webshop.reference'),
                    count: 30,
                    "is-optional": "",
                    placeholder: _unref(t)('platform.webshop.placeHolders.reference'),
                    "data-dusk": "cart-reference-input",
                    onInput: _unref(validateReference)
                  }, null, 8, ["modelValue", "label", "placeholder", "onInput"])
                ], 32)
              ], 2),
              _createElementVNode("div", _hoisted_34, [
                _createVNode(_unref(SearchInput), {
                  modelValue: _unref(patientSearchText),
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(patientSearchText) ? (patientSearchText).value = $event : null)),
                  label: _unref(t)('platform.webshop.patient'),
                  placeholder: _unref(t)('platform.webshop.placeHolders.search-patient'),
                  suggestions: _unref(patientSuggestions),
                  loading: _unref(isPatientSearchLoading),
                  clear: true,
                  icon: _ctx.item.patient !== null ? 'check-square' : 'search',
                  "is-optional": true,
                  "add-button-link-label": _unref(t)('platform.webshop.add-patient'),
                  "add-button-link": "add-patient",
                  "add-button-as-event": true,
                  "data-dusk": "patient-search-input",
                  onChange: _unref(handlePatientChange),
                  onAddButtonClick: _cache[10] || (_cache[10] = ($event: any) => (showModal.value = true))
                }, null, 8, ["modelValue", "label", "placeholder", "suggestions", "loading", "icon", "add-button-link-label", "onChange"])
              ])
            ]))
      ]),
      _: 1
    }, 16, ["item", "category", "editable", "is-loading", "data-dusk", "fallback-image"]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (showModal.value)
        ? (_openBlock(), _createBlock(AddPatientModal, {
            key: 0,
            "organisation-id": currentOrganisationId.value,
            onClose: _cache[14] || (_cache[14] = ($event: any) => (showModal.value = false)),
            onSuccess: handlePatientCreated
          }, null, 8, ["organisation-id"]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}
}

})